import { useQuery } from '@tanstack/react-query';
import { billing } from '@repletoryreach/sdk-api';

/** `meta` of the price list: the currency and VAT fields, whose prices these are and the plans to compare them with. */
export type RatesMeta = billing.TenantRatesEnvelope['meta'];

export interface RatesList {
  data: billing.TenantRate[];
  meta: RatesMeta;
}

/** The price list's key, for whatever changes the prices (a plan change) to invalidate. */
export const RATES_KEY = ['usage', 'rates'] as const;

/**
 * The price list, on the shared `['usage', 'rates']` key.
 *
 * The usage page declared this inline while it was the only reader. The plan
 * chooser and the ledger explanation read it too now, and one response carries
 * the price on every plan, so all three share one request for five minutes.
 */
export function useRates(enabled = true) {
  return useQuery({
    queryKey: RATES_KEY,
    queryFn: async (): Promise<RatesList> => {
      const res = await billing.listRates();
      return { data: res.data, meta: res.meta };
    },
    staleTime: 300_000,
    enabled
  });
}
